import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

    menuItems: Array<any>;

    constructor() {
        this.menuItems = [];
    }

    addMenu(items: Array<{
        id: string,
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>
    }>) {
        items.forEach((item) => {
            //if (item.text == 'Trang chủ' || item.text == 'Lịch hẹn' || item.text=='Báo cáo' || (item.submenu != null && item.submenu.length > 0))
          if (item.text == 'Trang chủ' || item.text == 'Quản lý dự án' || item.text == 'Lịch hẹn' || item.text == 'Báo cáo' || item.id==''
            ||
            //(item.submenu != null && item.submenu.length > 0)
              (item.submenu != null && item.submenu.length > 0 && item.submenu.filter((s) => s.text != null).length > 0) 
          )
                this.menuItems.push(item);
            
                
        });
    }

    getMenu() {
        return this.menuItems;
    }

}
